module.exports = __webpack_public_path__ + "static/media/a1.033a4553.jpg";